// Module
var code = "<admin-user-overview></admin-user-overview> ";
// Exports
module.exports = code;